export default {"src":"https://fishbrain.com/_next/static/media/indiana.d230d344.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};